import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';

import NPDatatable from '../../np-components/Datatable';
import { Paper, LinearProgress } from '@material-ui/core';
import useListFilter from '../../np-components/Datatable/listFilter';
import { getPalette, createActions } from '../product.utilities';

const styles = theme => ({
    paletteButtons: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        margin: theme.spacing(),
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    show: {
        display: 'block',
    },
    hide: {
        display: 'none',
    },
    columnHeaderStyle: {
        paddingTop: 20
    }
});

const DisplayProductList = props => {
    const { classes, displayProducts, onFetchDisplayProducts, columnsState, activeCustomer } = props;
    const loading = displayProducts.loading;
    const displayProductsCount = displayProducts.count;
    const displayProductsList = displayProducts.list;
    let tableID = 'DisplayProduct';
    let visible = columnsState && columnsState[tableID];

    const columns = [
        {
            displayName: 'Action',
            backendName: 'Action',
            options: {
                align: 'left',
                sortable: false,
                searchable: false,
                visible: visible ? visible['Action'] : true,
            }
        },
        {
            displayName: 'Securaze ID',
            backendName: 'InventoryID',
            options: {
                align: 'left',
                sortable: true,
                searchable: true,
                visible: visible ? visible['InventoryID'] : true,
            }
        },
        {
            displayName: 'Colli',
            backendName: 'Colli',
            options: {
                align: 'left',
                sortable: true,
                visible: visible ? visible['Colli'] : true,
                searchable: true
            }
        },
        {
            displayName: 'Chassis',
            backendName: 'ChassisType',
            options: {
                align: 'left',
                sortable: true,
                visible: visible ? visible['ChassisType'] : true,
                searchable: true
            }
        },
        {
            displayName: 'Model',
            backendName: 'ProductModel',
            options: {
                align: 'left',
                sortable: true,
                visible: visible ? visible['ProductModel'] : true,
                searchable: true
            }
        },
        {
            displayName: 'Serial',
            backendName: 'SerialNumber',
            options: {
                align: 'left',
                sortable: true,
                searchable: true,
                visible: visible ? visible['SerialNumber'] : true,
            }
        },
        {
            displayName: 'Grade',
            backendName: 'Grade',
            options: {
                align: 'left',
                sortable: true,
                searchable: true,
                visible: visible ? visible['Grade'] : true,
            }
        }
    ];

    let backendNames = [];
    columns.map(column => { if (column.backendName !== 'Action') backendNames.push(column.backendName); return null; })
    const listFilter = useListFilter({ rowsPerPage: 20, searchColumns: backendNames });

    // Fetch Calls if the filter was changed or after delete
    useEffect(() => {
        // fetch calls
        if (listFilter.filter) {
            onFetchDisplayProducts({ ...listFilter.filter, ActiveCustomerID: activeCustomer });
        }
    }, [listFilter.filter, onFetchDisplayProducts, activeCustomer]);

    const tableOptions = {
        isSelectable: true,
        tableSearch: false,
        tableID: 'DisplayProduct',
        saveColumn: true,
        page: 0,
        rowsPerPage: 20,
        count: displayProductsCount,
        rowsPerPageOptions: [20, 10, 20, 50, 75, 100, 'All'],
        tableTitle: 'Display Products',
        noMatch: "Sorry, no matching records found",
        onTableChange: listFilter.onTableChange,
        onSaveFilter: (columns) => {
            let objToSendColumn = {}
            let objColumns = {}
            columns.map(column => {
                objColumns[`${column.backendName}`] = column.options.visible
                return objColumns
            })
            objToSendColumn[`${tableID}`] = objColumns
            props.saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        }
    };

    let counter = 0;
    let productData = displayProductsList.map(product => {
        let returnObj = {};
        returnObj.index = counter;
        returnObj.selected = false;
        returnObj.id = product.ProductID;
        returnObj.visible = true;
        returnObj.values = [
            createActions(product.ProductID),
            product.InventoryID ? product.InventoryID : '[empty]',
            getPalette(product.ProductPaletteHistories, 'Colli', classes),
            'Display',
            product.DisplayProduct.Name ? product.DisplayProduct.Name : '[empty]',
            product.SerialNumber ? product.SerialNumber : '[empty]',
            product.Grade ? product.Grade.InternationalGrading : '[empty]',
        ];
        counter++;
        return returnObj;
    });
    return (
        <div>
            <LinearProgress className={loading ? classes.show : classes.hide} color="primary" />
            <Paper>
                <NPDatatable customStyles={classes} data={productData} columns={columns} options={tableOptions} />
            </Paper>
        </div>

    );
}

export default withStyles(styles, { withTheme: true })(DisplayProductList);